import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import dummyProfileImage from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import { MdAdd } from "react-icons/md";
import { FaMinus } from "react-icons/fa";
import ScannerLoader from "../components/ScannerLoader";
import { getCurrentDate } from "../utilities/getCurrentDate";
import {
  MDBFile,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCheckbox,
  MDBValidation,
  MDBTextArea,
  MDBBtn,
  MDBInput,
} from "mdb-react-ui-kit";
import formatDate from "../utilities/dateFormat";
import { extractFileNameAndExtension } from "../utilities/extractFileNameAndExtension";
import "../styles/verification.css";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import CameraPopup from "../components/CameraPopup";
import { useDispatch } from "react-redux";
import { clearImageData } from "../redux-toolkit/slices/imageSlice";
import { removeSignatureData } from "../redux-toolkit/slices/signatureSlice";
import { openCameraPopup } from "../redux-toolkit/slices/openCamSlice";
import SignaturePopup from "../components/SignaturePopup";
import Loader from "../components/Loader";
import convertToUnderscoreFormat from "../utilities/convertToUnderscoreFormat";
import { validateFormData } from "../utilities/validateVerificationForm";
import formatDateToDDMMYYYY from "../utilities/formatDateToDDMMYYYY";
import DatePickerComponent from "../components/DatePickerComponent";
import validateDocumentVerificationData from "../utilities/validateDocumentVerificationData";
import API_BASE_URL from "../utilities/apiConfig";
import REPORT_BASE_URL from "../utilities/reportConfig";
import axiosInstance from "../utilities/apiConfig";

const DocumentVerification = () => {
  const baseURL = axiosInstance.defaults.baseURL;
  const [id, setId] = useState(0);
  const [barId, setbarId] = useState("");
  const [profileImage, setProfileImage] = useState(dummyProfileImage);
  const [singatureImage, setSignatureImage] = useState(dummySignature);
  const [loading, setLoading] = useState(false);
  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);
  const [template1, setTemplate1] = useState("");
  const [template2, setTemplate2] = useState("");
  const [secugenLic, setSecugenLic] = useState("");
  const [quality, setQuality] = useState(100);
  const [imageSrc1, setImageSrc1] = useState(dummyFingerprint);
  const [showCameraPopup, setShowCameraPopup] = useState(false);
  const [renderedCameraPopup, setRenderedCameraPopup] = useState(0);
  const [renderedSignaturePopup, setRenderedSignaturePopup] = useState(0);
  const [showSignaturePopup, setShowSignaturePopup] = useState(false);
  const [imageSrc2, setImageSrc2] = useState(dummyFingerprint);
  const [isNewVerification, setIsNewVerifcation] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [showAadhar, setShowAadhar] = useState(false);
  const [showCoupan, setShowCoupan] = useState(false);
  const [showEntrollmentCertificate, setShowEntrollmentCertificate] =
    useState(false);
  const [showAIBECertificate, setShowAIBECertificate] = useState(false);
  const [showCOPCertificate, setShowCOPCertificate] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [relationships, setRelationships] = useState([]);
  const [feesDetails, setFeesDetails] = useState("");
  const [feesValidity, setFeesVaidity] = useState("");
  const token = useSelector((state) => state.auth.token);
  const [verifiactionFormValidationError, setVerifiactionFormValidationError] =
    useState("");

  const [isVerificationFormPrintable, setIsVerificationFormPrintable] =
    useState(false);
  const initialVerificationData = {
    verificationId: "",
    name: "",
    relationshipType: "",
    relativeName: "",
    advocateBarId: "",
    advocateAlternateBarId: "",
    concernedBarRegistrationDate: "",
    dateOfBirth: "",
    uttarakhandBarId: "",
    mobileNo: "",
    mobileNo2: "",
    email: "",
    experienceIn: "",
    yearsOfExperience: "",
    permanentAddress: "",
    localAddress: "",
    advocacyDocuments: "",
    enrollmentNo: "",
    enrollmentCertificate: "",
    aibePassCertificateNo: "",
    aibePassCertificate: "",
    copNo: "",
    copCertificate: "",
    copValitidy: "",
    aadharCertificate: "",
    isAnotherBarMember: "",
    barAssociationMembershipDetails: "",
    mentorAdvocateName: "",
    mentorAdvocateBarId: "",
    joiningDate: "",
    chamberNo: "",
    photo: "",
    fingerprintData: "",
    fingerprintImage: "",
    signature: "",
    verificationDate: "",
    status: "",
    userId: "",
  };

  const [verificationData, setVerificationData] = useState(
    initialVerificationData
  );

  const initialVerificationFormData = {
    name: "",
    relationshipType: "",
    relativeName: "",
    barAssociationId: 1,
    concernedBarRegistrationDate: "",
    dateOfBirth: "",
    advocateBarId: "",
    advocateAlternateBarId: "",
    mobileNo: "",
    mobileNo2: "",
    email: "",
    experienceIn: "",
    yearsOfExperience: "",
    permanentAddress: "",
    localAddress: "",
    advocacyDocuments: "",
    enrollmentNo: "",
    enrollmentCertificate: "",
    aibePassCertificateNo: "",
    aibePassCertificate: "",
    copNo: "",
    copCertificate: "",
    copValitidy: "",
    aadharCertificate: "",
    isAnotherBarMember: "",
    barAssociationMembershipDetails: "",
    mentorAdvocateName: "",
    mentorAdvocateBarId: "",
    joiningDate: "",
    chamberNo: "",
    photo: "",
    fingerprintData: "",
    fingerprintImage: "",
    signature: "",
    status: "",
    userId: "",
  };

  const [verificationFormData, setVerificationFormData] = useState(
    initialVerificationFormData
  );

  const [fileData, setFileData] = useState({
    aadharCertificate: null,
    profileImage: null,
    advocacyDocuments: null,
    enrollmentCertificate: null,
    aibePassCertificate: null,
    copCertificate: null,
  });

  const initialFessApiData = {
    advocateBarId: "",
    membershipTypeId: "",
    feesAmount: 0,
  };

  const [feesApiData, setFeesApiData] = useState(initialFessApiData);
  const [isFeesDataSend, setIsFeesDataSend] = useState(false);

  const dispatch = useDispatch();

  const [showCameraModalPopup, setShowCameraModalPopup] = useState(false);
  const handleCameraModalPopupClose = () => setShowCameraModalPopup(false);
  const handleCameraModalPopupShow = () => setShowCameraModalPopup(true);

  const [showSignatureModalPopup, setShowSignatureModalPopup] = useState(false);
  const handleSignatureModalPopupClose = () =>
    setShowSignatureModalPopup(false);
  const handleSignatureModalPopupShow = () => setShowSignatureModalPopup(true);

  const handleGetVerificationData = async () => {
    try {
      // debugger;
      setLoading(true);
      setIsVerificationFormPrintable(false);
      setShowDocuments(false);
      setVerificationData(initialVerificationData);
      setVerificationFormData(initialVerificationFormData);
      setFeesApiData(initialFessApiData);
      setProfileImage(dummyProfileImage);
      setSignatureImage(dummySignature);
      setImageSrc2(dummyFingerprint);
      dispatch(clearImageData());
      dispatch(removeSignatureData());
      console.log(barId);
      if (barId !== null) {
        const formatted_bar_id = convertToUnderscoreFormat(barId);
        console.log(formatted_bar_id);
        const response = await axiosInstance.get(
          `/Verification/${formatted_bar_id}`
        );
        console.log("Verifiaction data for Bar Id", response.data);

        if (response.data?.response.statusCode === 404) {
          setIsNewVerifcation(true);
          console.log("Is new verifiaction", isNewVerification);
          toast.error(response.data?.response.status);
          setVerificationData(initialVerificationData);
          setVerificationFormData({
            ...verificationFormData,
            advocateBarId: barId,
          });
          setFeesApiData({
            ...feesApiData,
            advocateBarId: barId,
          });
          setProfileImage(dummyProfileImage);
          setSignatureImage(dummySignature);
        } else {
          setIsNewVerifcation(false);
          setVerificationData(response.data?.advocateDetails);
          setVerificationFormData(response.data?.advocateDetails);

          setFeesDetails(response.data?.feesdetails);
          setFeesApiData({
            ...feesApiData,
            advocateBarId: response.data?.advocateDetails.advocateBarId,
          });
          // toast.success(response.data?.response.status + ' Please Verify Details');
          toast.success(" Please Verify Details");
          if (
            response.data?.feesdetails.feesStatusCode === 202 &&
            response.data?.feesvalidity
          ) {
            setFeesVaidity(response.data?.feesvalidity);
          } else if (response.data?.feesdetails.feesStatusCode === 200) {
            setFeesVaidity("LifeTime");
          } else {
            setFeesVaidity("Not Submitted");
          }
          setShowVerification(true);

          // COMMENT BY KHALID STARTS

          // setProfileImage(
          //   `${baseURL}/Verification/${response.data?.advocateDetails?.photo}` ||
          //     dummyProfileImage
          // );
          // setSignatureImage(
          //   `${baseURL}/Verification/${response.data?.advocateDetails?.signature}` ||
          //     dummyProfileImage
          // );
          // setImageSrc2(
          //   `${baseURL}/Verification/${response.data?.advocateDetails?.fingerprintImage}` ||
          //     dummyProfileImage
          // );

          // COMMENT BY KHALID ENDS

          // CHANGES MADE BY KHALID STARTS

          const imageUrl = `/Verification/${response.data?.advocateDetails?.photo}`;

          try {
            debugger; // DocuVeri
            const response = await axiosInstance.get(imageUrl, {
              responseType: "blob", // Important for image fetching
            });

            const imageBlob = URL.createObjectURL(response.data); // Create a URL for the blob
            setProfileImage(imageBlob); // Set the image state
          } catch (error) {
            console.error("Error fetching profile image:", error);
            setProfileImage(dummyProfileImage); // Fallback to dummy image on error
          }

          // Fetch and set the signature image
          const signatureImageUrl = `/Verification/${response.data?.advocateDetails?.signature}`;

          try {
            const signatureResponse = await axiosInstance.get(
              signatureImageUrl,
              {
                responseType: "blob", // Important for image fetching
              }
            );

            const signatureBlob = URL.createObjectURL(signatureResponse.data); // Create a URL for the blob
            setSignatureImage(signatureBlob); // Set the signature image state
          } catch (error) {
            console.error("Error fetching signature image:", error);
            setSignatureImage(dummySignature); // Fallback to dummy signature on error
          }

          // Fetch and set the fingerprint image
          const fingerprintImageUrl = `/Verification/${response.data?.advocateDetails?.fingerprintImage}`;

          try {
            const fingerprintResponse = await axiosInstance.get(
              fingerprintImageUrl,
              {
                responseType: "blob", // Important for image fetching
              }
            );

            const fingerprintBlob = URL.createObjectURL(
              fingerprintResponse.data
            ); // Create a URL for the blob
            setImageSrc2(fingerprintBlob); // Set the fingerprint image state
          } catch (error) {
            console.error("Error fetching fingerprint image:", error);
            setImageSrc2(dummyFingerprint); // Fallback to dummy fingerprint on error
          }

          // CHANGES MADE BY KHALID ENDS

          setShowAadhar(false);
          setShowCoupan(false);
          setShowAIBECertificate(false);
          setShowCOPCertificate(false);
          setShowEntrollmentCertificate(false);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputFieldChange = (e) => {
    const { name, value } = e.target;
    setVerificationData({
      ...verificationData,
      [name]: value,
    });

    setVerificationFormData((prevState) => {
      // Logging prevState and fileData for debugging
      console.log("Previous State of Verification Form Data:", prevState);
      console.log("Updated State of Verification Form Data:", verificationData);

      return {
        ...prevState,
        [name]: value,
      };
    });

    console.log(
      "Updated State of Verification Form Data:",
      verificationFormData
    );
    console.log("Handle Input Field Change", "=>", name, " : ", value);
  };

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];
    setFileData({
      ...fileData,
      [fileType]: file,
    });

    console.log("Handle Input Field Change", "=>", fileType, " : ", file);
    setVerificationFormData((prevState) => {
      // Logging prevState and fileData for debugging
      console.log("Previous State:", prevState);
      console.log("File Data:", fileData);

      return {
        ...prevState,
        [fileType]: file,
      };
    });
  };

  const handleSignaturePopupToggle = () => {
    setShowSignaturePopup(!showSignaturePopup);
  };

  const fetchRelationships = async () => {
    try {
      const response = await axiosInstance.get(`/Master/get_relations`);
      setRelationships(response.data);
      console.log("Relations Response from Verification", response.data);
    } catch (error) {
      console.error("Error fetching relationships:", error);
    }
  };

  useEffect(() => {
    fetchRelationships();
  }, []);

  useEffect(() => {
    console.log("testng form verification camera popup", showCameraPopup);
  }, [showCameraPopup]);

  const imageData = useSelector((state) => state.profileimage?.imageData);
  const signatureData = useSelector((state) => state.singature?.signatureData);
  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);
  const ReduxState = useSelector((state) => state);

  const handleUpdateDocuments = async () => {
    console.log(fileData);

    // Log the updated state after it's been updated
    console.log("Updated verification data:", verificationFormData);
    console.log("Updated verification file:", fileData);

    const validationErrors =
      validateDocumentVerificationData(verificationFormData);

    if (Object.keys(validationErrors).length > 0) {
      setVerifiactionFormValidationError(validationErrors);
      Object.values(validationErrors).forEach((error) => {
        toast.error(error);
      });
    } else {
      try {
        setLoading(true);
        const response = await axiosInstance.put(
          `/Verification/update_varification_documents`,

          verificationFormData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              accept: "*/*",
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        );
        console.log("Data updated successfully", response.data);
        if (response.data?.statusCode === 200) {
          toast.success(response.data?.status);
          setShowVerification(false);
          setIsVerificationFormPrintable(true);
        } else {
          toast.error(response.data?.status);
        }
      } catch (error) {
        console.error("Handle Update Error:", error);
        toast.error("Failed to Updated Detilas Please Try Again");
        if (error.response) {
          console.error("Response data:", error.response.data);
          console.error("Response status:", error.response.status);
          console.error("Response headers:", error.response.headers);
        } else if (error.request) {
          console.error("Request data:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const feesMembershipTypes = [
    { value: "1", label: "Yearly" },
    { value: "2", label: "Lifetime" },
  ];

  useEffect(() => {
    console.log(
      "Updated fingerprint data",
      verificationFormData.fingerprintData
    );
    console.log(
      "Updated fingerprint Image",
      verificationFormData.fingerprintImage
    );
  }, [verificationFormData.fingerprintData, verificationData.fingerprintImage]);
  useEffect(() => {
    if (imageData) {
      setProfileImage(imageData);
      setVerificationFormData({
        ...verificationFormData,
        photo: imageData,
      });
    }
    // else {
    //   setProfileImage(dummyProfileImage);
    // }
    console.log("image data of verification page", imageData);
  }, [imageData, dummyProfileImage]);

  useEffect(() => {
    if (signatureData) {
      setSignatureImage(signatureData);
      setVerificationFormData({
        ...verificationFormData,
        signature: signatureData,
      });
    }
    // else {
    //   setSignatureImage(dummySignature);
    // }
    console.log("signature data of verification page", signatureData);
  }, [signatureData, dummySignature]);

  useEffect(() => {
    setVerificationFormData({
      ...verificationFormData,
      userId: userDeatils?.userId,
    });
    console.log("User Id From Login Session", verificationFormData.userId);
  }, [loading, verificationData.userId]);

  // Added by khalid starts

  const handleViewDocument = async (
    verificationData,
    documentType,
    documentFileName
  ) => {
    debugger;
    try {
      setLoading(true);
      // Fetch the document with the correct headers and response type for Blob
      const response = await axiosInstance.get(
        `/File/${documentType}/${documentFileName}`,
        { responseType: "blob" }
      );

      // Get the file type (MIME type) from the response
      const fileType = response.headers["content-type"];

      // Create a Blob URL for the fetched file
      const fileURL = URL.createObjectURL(response.data);

      // Handle different file types
      if (fileType.startsWith("image/")) {
        // Open image in a new tab
        window.open(fileURL, "_blank");
      } else if (fileType === "application/pdf") {
        // Open PDF in a new tab
        window.open(fileURL, "_blank");
      } else if (fileType === "text/plain") {
        // Handle text file and display its content
        const text = await response.data.text();
        const textWindow = window.open();
        textWindow.document.write(`<pre>${text}</pre>`);
      } else {
        // For other file types, you can download or display it accordingly
        window.open(fileURL, "_blank");
      }
    } catch (error) {
      console.error("Error viewing document:", error);
      alert("Failed to view document: " + error.message);
    } finally {
      // Set loading state to false after the document fetch attempt (success or failure)
      setLoading(false);
    }
  };

  // Added by khalid ends

  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}
      <CameraPopup
        show={showCameraModalPopup}
        handleClose={handleCameraModalPopupClose}
      />
      <SignaturePopup
        show={showSignatureModalPopup}
        handleClose={handleSignatureModalPopupClose}
      />

      <MDBValidation className="row mt-5 p-3 justify-content-center">
        {showVerification ? (
          <h3 className="text-center mb-5">
            <b>Verify Advocate Details And Upload Documents</b>
          </h3>
        ) : (
          <h3 className="text-center mb-5">
            <b>Enter Advocate Bar Id for Documents Verification</b>
          </h3>
        )}

        <div className="row mb-5 justify-content-center">
          <div
            feedback="Please Enter Bar Id."
            invalid
            className="col-md-3 mb-1 d-flex justify-content-end"
          >
            <MDBInput
              required
              value={barId}
              onChange={(e) => setbarId(e.target.value)}
              label="Enter Bar Id"
              type="text"
              name="barId"
              className="m-0"
              id="barId"
            />
          </div>

          {isVerificationFormPrintable ? (
            <div className="col-md-8 col-xl-5 col-xxl-4 mb-1 d-flex">
              <MDBBtn
                onClick={() => {
                  handleGetVerificationData();
                }}
              >
                Get Data
              </MDBBtn>
              &nbsp;
              <>
                <a
                  href={`${REPORT_BASE_URL}/Verification.aspx?id=${barId}`}
                  target="_blank"
                >
                  <MDBBtn className="btn btn-danger" type="button">
                    Print
                  </MDBBtn>
                </a>
              </>
            </div>
          ) : (
            <div className="col-md-2 mb-1 ">
              <MDBBtn
                onClick={() => {
                  handleGetVerificationData();
                }}
              >
                Get Data
              </MDBBtn>
            </div>
          )}
        </div>

        {showVerification && (
          <>
            <div className="row justify-content-center mb-4 ">
              <div className="col-xxl-8">
                <div className="row">
                  <div
                    invalid
                    feedback="Please provide a valid name."
                    className="col-sm-6 col-md-4 col-xl-3 align-self-end"
                  >
                    <MDBInput
                      required
                      label="Advocate Name"
                      id="name"
                      name="name"
                      value={verificationData?.name}
                      type="text"
                      className="mb-0"
                    />
                  </div>

                  <div className="col-sm-6 col-md-5 col-xl-4 align-self-end">
                    <div className="input-group mb-0">
                      <select
                        className="form-select form-select-sm py-0 "
                        style={{
                          height: "calc(1.5em + 0.75rem + 2px)",
                          width: "30%",
                        }}
                        value={verificationData?.relationshipType}
                        name="relationshipType"
                        id="relationshipType"
                        required // This makes the select field required
                      >
                        <option value="#" aria-readonly disabled>
                          --
                        </option>
                        {relationships.map((item, key) => (
                          <option key={key} value={item.relationshipType}>
                            {item.relationshipSymbol.toUpperCase()}
                          </option>
                        ))}
                      </select>

                      <div
                        className="input-group-append"
                        style={{ width: "70%" }}
                      >
                        <MDBInput
                          required
                          label="Relative Name"
                          id="relativeName"
                          name="relativeName"
                          value={verificationData?.relativeName}
                          type="text"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-4 col-xl-3 ms-auto">
                    {feesDetails?.feesStatusCode === 200 && (
                      <>
                        <strong>Membership Validity : </strong>
                        <span className="badge rounded-pill badge-success bg-success">
                          {feesValidity}
                        </span>
                      </>
                    )}
                    {feesDetails?.feesStatusCode === 202 &&
                      feesDetails?.feesInfo === "YEARLY" &&
                      feesValidity !== "NOT SUBMITTED" && (
                        <>
                          <strong>Membership Validity : </strong>
                          <span className="badge rounded-pill badge-info bg-success">
                            {feesValidity}
                          </span>
                        </>
                      )}
                    {feesDetails?.feesStatusCode === 202 &&
                      feesDetails?.feesInfo === "YEARLY" &&
                      feesValidity === "NOT SUBMITTED" && (
                        <>
                          <strong>Membership Validity : </strong>
                          <span className="badge rounded-pill badge-info bg-danger">
                            {feesValidity}
                          </span>
                        </>
                      )}
                    {feesDetails?.feesStatusCode === 202 &&
                      feesDetails?.feesInfo !== "YEARLY" && (
                        <>
                          <strong>Membership Validity : </strong>
                          <span className="badge rounded-pill badge-info bg-danger">
                            {feesValidity}
                          </span>
                        </>
                      )}
                    {feesDetails?.feesStatusCode === 404 && (
                      <>
                        <strong>Membership Validity : </strong>
                        <span className="badge rounded-pill badge-info bg-danger">
                          {feesDetails?.feesInfo}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-3">
              <div
                feedback="Please provide a valid city."
                invalid
                className="col-sm-6 col-md-3 col-xxl-2"
              >
                <MDBInput
                  required
                  label="Mobile No"
                  id="mobileNo"
                  name="mobileNo"
                  value={verificationData?.mobileNo}
                  type="text"
                />
              </div>
              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  label="Email"
                  id="email"
                  name="email"
                  value={verificationData?.email}
                  type="email"
                />
              </div>
              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  required
                  label="Experience in"
                  id="experienceIn"
                  name="experienceIn"
                  value={verificationData?.experienceIn}
                  type="text"
                />
              </div>
              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  required
                  label="Year of Experiance"
                  id="yearsOfExperience"
                  name="yearsOfExperience"
                  value={
                    verificationData?.yearsOfExperience
                      ? verificationData?.yearsOfExperience
                      : ""
                  }
                  type="number"
                />
              </div>
            </div>

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-sm-6 col-md-4 col-xl-3">
                    <MDBInput
                      label="Second Mobile No"
                      id="mobileNo2"
                      name="mobileNo2"
                      value={verificationData?.mobileNo2}
                      type="number"
                    />
                  </div>

                  <div className="col-sm-6 col-md-4 col-xl-3">
                    <MDBInput
                      label="Alternate Bar Id"
                      id="advocateAlternateBarId"
                      name="advocateAlternateBarId"
                      value={
                        barId === verificationData?.advocateAlternateBarId
                          ? verificationData?.advocateBarId
                          : verificationData?.advocateAlternateBarId
                      }
                      type="text"
                    />
                  </div>

                  <div className="col-sm-6 col-md-4 col-xl-3">
                    <MDBInput
                      required
                      label="Dehradun Bar Reg Year"
                      id="concernedBarRegistrationDate"
                      name="concernedBarRegistrationDate"
                      min="1960-01-01"
                      max={getCurrentDate()}
                      value={verificationData?.concernedBarRegistrationDate}
                      type="date"
                    />
                  </div>

                  <div className="col-sm-6 col-md-4 col-xl-3">
                    <MDBInput
                      required
                      label="Date of Birth"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      min="1947-01-01"
                      max={getCurrentDate()}
                      value={verificationData?.dateOfBirth}
                      type="date"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div data-mdb-input-init className="form-outline">
                  <label className="form-label" htmlFor="textAreaExample3">
                    Current Address
                  </label>
                  <MDBTextArea
                    required
                    className="form-control"
                    id="localAddress"
                    name="localAddress"
                    value={verificationData?.localAddress}
                    rows="2"
                  ></MDBTextArea>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div data-mdb-input-init className="form-outline">
                  <label className="form-label" htmlFor="textAreaExample3">
                    Permanent Address
                  </label>
                  <MDBTextArea
                    required
                    className="form-control"
                    id="permanentAddress"
                    name="permanentAddress"
                    value={verificationData?.permanentAddress}
                    rows="2"
                  ></MDBTextArea>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-md-1 d-flex justify-content-center align-items-center py-auto">
                    <MDBBtn
                      className="rounded-pill mb-3"
                      style={{ fontSize: ".8rem" }}
                      rounded
                      onClick={() => {
                        setShowDocuments(!showDocuments);
                      }}
                    >
                      {showDocuments ? <span> – </span> : <span> + </span>}
                    </MDBBtn>
                  </div>
                </div>
              </div>
            </div>

            {showDocuments && (
              <>
                {/* <div className="row justify-content-center my-2">
                <div className="col-xxl-8">
                  <p className="fw-bolder">
                    Information realted to case filed to the court in the last two
                    years and advocacy Letters/Memos/Registry
                  </p>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-xxl-8">
                  <div className="row">

                    {!isNewVerification && <div className="col-md-3 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3"
                        style={{ fontSize: ".8rem", width: '100%' }}
                        rounded
                      >
                        <a
                          href={`${API_BASE_URL}/File/view_advocacy_documnets/${extractFileNameAndExtension(
                            verificationData?.advocacyDocuments
                          )}`}
                          target="_blank"
                          className="d-block w-100"

                        >
                          View Advocacy Documents
                        </a>
                      </MDBBtn>
                    </div>}


                    {!showCoupan && !isNewVerification && (<div className="col-md-1 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3"
                        style={{ fontSize: ".8rem" }}
                        rounded
                        onClick={() => { setShowCoupan(!showCoupan) }}
                      >
                        +
                      </MDBBtn>
                    </div>)}

                    {(isNewVerification || showCoupan) &&
                      <div className="col-md-4">
                        <MDBFile required
                          className=""
                          label="Add New Coupan"
                          id="advocacyDocuments"
                          name="advocacyDocuments"
                          onChange={(e) => handleFileChange(e, "advocacyDocuments")}
                          type="file"
                        />
                      </div>}

                  </div>
                </div>
              </div> */}

                <div className="row justify-content-center mb-2 mt-3">
                  <div className="col-xxl-8">
                    <p className="fw-bolder my-0">Documents</p>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-xxl-8">
                    <div className="row">
                      {!isNewVerification && (
                        <div className="col-md-3 d-flex justify-content-start align-items-end py-auto">
                          <MDBBtn
                            className="rounded-pill mb-3 "
                            style={{ fontSize: ".8rem", width: "100%" }}
                            rounded
                          >
                            <a
                              // href={`${baseURL}/File/view_aadhar_documnets/${extractFileNameAndExtension(
                              //   verificationData?.aadharCertificate
                              // )}`}
                              onClick={(e) => {
                                e.preventDefault();
                                handleViewDocument(
                                  verificationData,
                                  "view_aadhar_documnets",
                                  extractFileNameAndExtension(
                                    verificationData.aadharCertificate
                                  )
                                );
                              }}
                              target="_blank"
                              className="d-block w-100"
                            >
                              View Documents
                            </a>
                          </MDBBtn>
                        </div>
                      )}
                      {!showAadhar && !isNewVerification && (
                        <div className="col-md-1 d-flex justify-content-start align-items-end py-auto">
                          <MDBBtn
                            className="rounded-pill mb-3"
                            style={{ fontSize: ".8rem" }}
                            rounded
                            onClick={() => {
                              setShowAadhar(!showAadhar);
                            }}
                          >
                            +
                          </MDBBtn>
                        </div>
                      )}

                      {(isNewVerification || showAadhar) && (
                        <div className="col-md-4">
                          <MDBFile
                            required
                            className=""
                            label="Upload Documents"
                            id="aadharCertificate"
                            name="aadharCertificate"
                            onChange={(e) =>
                              handleFileChange(e, "aadharCertificate")
                            }
                            type="file"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* <div className="row justify-content-center my-2">
                <div className="col-xxl-8">
                  <div className="row">
                    {!isNewVerification && <div className="col-md-3 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3"
                        style={{ fontSize: ".8rem", width: '100%' }}
                      >
                        <a
                          href={`${API_BASE_URL}/File/view_enrollment_certificate/${extractFileNameAndExtension(
                            verificationData?.enrollmentCertificate
                          )}`}
                          target="_blank"
                          className="d-block w-100"
                        >
                          View Enrollment Certificate
                        </a>
                      </MDBBtn>
                    </div>}

                    {!showEntrollmentCertificate && !isNewVerification && (<div className="col-md-1 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3"
                        style={{ fontSize: ".8rem" }}
                        rounded
                        onClick={() => { setShowEntrollmentCertificate(!showEntrollmentCertificate) }}
                      >
                        +
                      </MDBBtn>
                    </div>)}

                    {(isNewVerification || showEntrollmentCertificate) &&

                      <div className="col-md-4">
                        <MDBFile required
                          className=""
                          label="Add New Enrollment Certificate"
                          id="enrollmentCertificate"
                          name="enrollmentCertificate"
                          onChange={(e) =>
                            handleFileChange(e, "enrollmentCertificate")
                          }
                          type="file"
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div className="row justify-content-center my-2">
                <div className="col-xxl-8">
                  <div className="row">
                    {!isNewVerification && <div className="col-md-3 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3 px-3"
                        style={{ fontSize: ".8rem", width: '100%' }}
                      >
                        <a
                          href={`${API_BASE_URL}/File/view_aibe_pass_certificate/${extractFileNameAndExtension(
                            verificationData?.aibePassCertificate
                          )}`}
                          target="_blank"
                          className="d-block w-100"
                        >
                          View AIBE Pass Certificate
                        </a>
                      </MDBBtn>
                    </div>

                    }

                    {!showAIBECertificate && !isNewVerification && (<div className="col-md-1 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3"
                        style={{ fontSize: ".8rem" }}
                        rounded
                        onClick={() => { setShowAIBECertificate(!showAIBECertificate) }}
                      >
                        +
                      </MDBBtn>
                    </div>)}

                    {(isNewVerification || showAIBECertificate) &&

                      <div className="col-md-4">
                        <MDBFile required
                          className=""
                          label="Add New AIBE Certificate"
                          id="aibePassCertificate"
                          name="aibePassCertificate"
                          onChange={(e) =>
                            handleFileChange(e, "aibePassCertificate")
                          }
                          type="file"
                        />
                      </div>
                    }



                  </div>
                </div>
              </div>

              <div className="row justify-content-center my-2">
                <div className="col-xxl-8">
                  <div className="row">
                    {!isNewVerification && <div className="col-md-3 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3"
                        style={{ fontSize: ".8rem", width: '100%' }}
                     
                      >
                        <a
                          href={`${API_BASE_URL}/File/view_cop_certificate/${extractFileNameAndExtension(
                            verificationData?.copCertificate
                          )}`}
                          target="_blank"
                          className="d-block w-100"
                        >
                          View COP Certificate
                        </a>
                      </MDBBtn>
                    </div>}


                    {!showCOPCertificate && !isNewVerification && (<div className="col-md-1 d-flex justify-content-start align-items-end py-auto">

                      <MDBBtn
                        className="rounded-pill mb-3"
                        style={{ fontSize: ".8rem" }}
                        rounded
                        onClick={() => { setShowCOPCertificate(!showCOPCertificate) }}
                      >
                        +
                      </MDBBtn>
                    </div>)}

                    {(isNewVerification || showCOPCertificate) &&

                      <div className="col-md-4">
                        <MDBFile required
                          className=""
                          label="Add New COP Certificate"
                          id="copCertificate"
                          name="copCertificate"
                          onChange={(e) => handleFileChange(e, "copCertificate")}
                          type="file"
                        />
                      </div>
                    }
                  </div>
                </div>
              </div> */}

                <div className="row justify-content-center my-2">
                  <div className="col-xxl-8">
                    <div className="row">
                      <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                        <MDBInput
                          required
                          label="Enrollment Certificate No"
                          id="enrollmentNo"
                          name="enrollmentNo"
                          value={verificationData?.enrollmentNo}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          type="text"
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                        <MDBInput
                          required
                          label="AIBE Pass Certificate No"
                          id="aibePassCertificateNo"
                          name="aibePassCertificateNo"
                          value={verificationData?.aibePassCertificateNo}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          type="text"
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                        <MDBInput
                          required
                          label="COP No"
                          id="copNo"
                          name="copNo"
                          value={verificationData?.copNo}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          type="text"
                        />
                      </div>

                      <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                        <MDBInput
                          required
                          label="COP Validity"
                          id="copValitidy"
                          name="copValitidy"
                          min="2000-01-01"
                          max={getCurrentDate()}
                          value={verificationData?.copValitidy}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          dateFormat="dd/MM/yyyy"
                          type="date"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-center my-3">
                  <div className="col-xxl-8">
                    <p className="fw-bolder m-0">
                      With Which Advocate you are working with in the Dehradun
                      Court (Experiance of the concerned should be at least 10
                      years and should be the member of the Bar Association,
                      Deharadun) Qualification
                    </p>
                  </div>
                </div>

                <div className="row justify-content-center my-3">
                  <div className="col-xxl-8">
                    <div className="row">
                      <div className="col-md-3  mt-auto">
                        <MDBInput
                          required
                          id="mentorAdvocateName"
                          name="mentorAdvocateName"
                          value={verificationData?.mentorAdvocateName}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          label="Mentor Advocate Name"
                          type="text"
                        />
                      </div>
                      <div className="col-md-3  mt-auto">
                        <MDBInput
                          required
                          id="mentorAdvocateBarId"
                          name="mentorAdvocateBarId"
                          value={verificationData?.mentorAdvocateBarId}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          label="Bar Id"
                          type="text"
                        />
                      </div>
                      <div className="col-md-3 ">
                        <MDBInput
                          required
                          id="joiningDate"
                          name="joiningDate"
                          min="1960-01-01"
                          max={getCurrentDate()}
                          value={verificationData?.joiningDate}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          label="Date"
                          type="date"
                        />
                      </div>
                      <div className="col-md-3  mt-auto">
                        <MDBInput
                          required
                          id="chamberNo"
                          name="chamberNo"
                          value={verificationData?.chamberNo}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                          label="Chamber No"
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-center my-2">
                  <div className="col-xxl-8">
                    <MDBCheckbox
                      id="controlledCheckbox"
                      checked={verificationData?.isAnotherBarMember}
                      onChange={(event) => {
                        setVerificationData({
                          ...verificationData,
                          isAnotherBarMember: event.target.checked,
                        });
                        setVerificationFormData({
                          ...verificationFormData,
                          isAnotherBarMember: event.target.checked,
                        });
                      }}
                      className="fw-bolder"
                      label="At Present if you are a member of any bar Association"
                    />
                  </div>
                </div>

                <div className="row justify-content-center mb-2">
                  <div className="col-xxl-8">
                    <div data-mdb-input-init className="form-outline">
                      <label className="form-label" htmlFor="textAreaExample3">
                        Details Related to Other Bar Association
                      </label>
                      <MDBTextArea
                        {...(verificationData?.isAnotherBarMember && {
                          required: true,
                        })}
                        className="form-control"
                        id="barAssociationMembershipDetails"
                        name="barAssociationMembershipDetails"
                        value={
                          verificationData?.barAssociationMembershipDetails
                        }
                        onChange={(e) => {
                          handleInputFieldChange(e);
                        }}
                        rows="2"
                      ></MDBTextArea>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="row justify-content-center my-2">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={profileImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          ProfileImage
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={imageSrc2}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Fingerprint
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={singatureImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Signature
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center my-5">
              {/* {isVerificationFormPrintable ? (<div className="col-md-4 mb-1">
                <MDBBtn
                >
                  <a
                    href={`https://report.barassociationdehradun.com/Report/Verification.aspx?id=${barId}`}
                    target="_blank"
                    className="d-block w-100"
                  >
                    Print Verification Slip
                  </a>
                </MDBBtn>
              </div>) : (<div className="col-md-2 mb-1">
                <MDBBtn
                  onClick={() => {
                    handleUpdateDocuments();
                  }}
                >
                  Update Deatils
                </MDBBtn>
              </div>)} */}

              <div className="col-md-2 mb-1">
                <MDBBtn
                  onClick={() => {
                    handleUpdateDocuments();
                  }}
                >
                  Update Deatils
                </MDBBtn>
              </div>
            </div>
          </>
        )}
      </MDBValidation>
    </>
  );
};

export default DocumentVerification;
